module.exports = __webpack_public_path__ + "media/images/athletes/1704-0de7ca2b5be644341517802251f7405e.png";